import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import transNavEn from './translations/en/nav.json'
import transNavDe from './translations/de/nav.json'
import transGlobalEn from './translations/en/global.json'
import transGlobalDe from './translations/de/global.json'
import settingsDe from './translations/de/settings.json'
import settingsEn from './translations/en/settings.json'
import commonDe from './translations/de/common.json'
import commonEn from './translations/en/common.json'
import loginDe from './translations/de/login.json'
import { toSnakeCase } from './helpers/stringHelper'

const resources = {
    en: {
        common: commonEn,
        nav: transNavEn,
        global: transGlobalEn,
        settings: settingsEn,
    },
    de: {
        login: loginDe,
        common: commonDe,
        nav: transNavDe,
        global: transGlobalDe,
        settings: settingsDe,
    },
}
const plugin_id = process.env.REACT_APP_PLUGIN_ID ?? 'zr-onboarding-workwear'
const saveLang = `${toSnakeCase(plugin_id)}_language`

i18next
    .use(initReactI18next)
    .init({
        resources,
        lng: localStorage.getItem(saveLang) ?? 'de',
        fallbackLng: 'en',
    })
    .then(() => {})

export default i18next
